(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-image-text-c-v4"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const viewAllIngredients = document.querySelector('.view-all-ingredients');
    const ingredientsListText = document.querySelector('.ingredients-list-text');
    const chevron = document.querySelector('.faq-chevron');

    if (viewAllIngredients && ingredientsListText && chevron) {
      viewAllIngredients.addEventListener('click', function () {
        // Toggle the ingredients list text
        ingredientsListText.classList.toggle('show');

        // Rotate the chevron icon
        if (ingredientsListText.classList.contains('show')) {
          chevron.style.transform = 'rotate(0deg)';
          viewAllIngredients.querySelector('span').textContent = 'Hide Ingredients';
        } else {
          chevron.style.transform = 'rotate(180deg)';
          viewAllIngredients.querySelector('span').textContent = 'View All Ingredients';
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
